import React from 'react';
import './Login.css';

const Login = () => (
  <div className="login-page">
    <div className="login-card">
      <div className="login-logo">CWARA</div>
      <h1>Admin Login</h1>
      <p>Sign in with your Microsoft account to access the committee admin panel.</p>
      <a
        href="/.auth/login/aad?post_login_redirect_uri=/admin"
        className="btn btn-primary login-btn"
      >
        Sign in with Microsoft
      </a>
      <p className="login-note">
        Access is restricted to authorised committee members only.
      </p>
    </div>
  </div>
);

export default Login;
